export const en = {
  // KAN-95 dark room (endoscopy suite) theme toggle
  theme: {
    switch_to_dark: 'Switch to dark mode',
    switch_to_light: 'Switch to light mode',
  },
  license: {
    deadline: 'Deadline (Bangkok time): {value}',
    sync_stale: 'Using the last trusted state; last sync (Bangkok time): {value}',
    sync_unknown: 'sync time unavailable',
    restored: 'The license has been restored. Full functionality is available again.',
    banner: {
      region_label: 'License status',
      grace: { title: 'License grace period', body: 'All functions remain available. Please contact your administrator to renew.' },
      degraded: { title: 'License restricted', body: 'Only existing history can be viewed, previewed, printed, or exported.' },
      suspended: { title: 'Historical export only', body: 'Only sign-in and historical file export remain available.' },
    },
    restricted: {
      clinical_write: 'The current license does not allow creating or changing clinical data.',
      report_generate: 'The current license does not allow generating or delivering new reports.',
      history_read: 'The current license only allows historical file export.',
      history_print: 'The current license does not allow printing this page.',
    },
    history_export: {
      limited_access: 'LIMITED ACCESS', title: 'Historical Examination Export', suspended_title: 'Only historical data can be exported now', description: 'Downloads saved reports and images only; no clinical data is created, changed, or regenerated.', open: 'History export',
      from: 'From', to: 'To', acc_no: 'Accession number', medical_record: 'Medical record', patient: 'Patient', date: 'Exam date',
      search: 'Search', clear: 'Clear filters', loading: 'Loading saved files…', empty_all: 'There are no saved files available to export.', empty_filtered: 'No saved files match these filters.', retry: 'Retry', back: 'Back to home',
      download: 'Download', download_format: 'Download {format}', download_artifact: 'Download {format}, examination {exam}, file {artifact}', download_zip: 'Download ZIP', selected: '{count} file(s) selected',
      zip_disabled_empty: 'Select at least one file first.', zip_disabled_offline: 'Reconnect to the network before downloading a ZIP.',
      select_artifact: 'Select {filename} for accession {accNo}',
      errors: { server: 'Files are temporarily unavailable. Please retry.', offline: 'You are offline. Retry after reconnecting.', expired: 'The file was removed or expired. Search again.' },
    },
  },
  // PACS image review (retrieve historical DICOM from hospital PACS)
  pacs: {
    open_viewer: 'View PACS Images',
    viewer_title: 'PACS Historical Images',
    studies: 'Studies',
    querying: 'Querying...',
    no_study: 'No PACS images found for this patient',
    no_desc: '(no description)',
    retrieving: 'Retrieving images, please wait...',
    no_patient_context: 'Missing patient info, cannot query PACS',
    no_image_retrieved: 'No images retrieved for this study',
    decode_error: 'Failed to decode image (possibly unsupported compression)',
    accession: 'Accession',
    image_count: '{count} image(s)',
    // Partial failure: images did load, but not all of them — say so explicitly
    partial_failed:
      '{failed} image(s) failed to retrieve; what you see is incomplete',
  },
  report: {
    Unedited: 'Unedited',
    Editing: 'Editing',
    Finalized: 'Finalized',
    exam_info: 'Exam. Info',
    findings: 'Findings',
    impression: 'Impression',
    key_images: 'Key Images',
    more_images: 'More Images',
    diagnosis: 'Diagnosis',
    suggestion: 'Suggestion',
    summary: 'Summary',
    auto_generate: 'Auto Generate',
    generating_descriptive_paragraph: 'Generating descriptive paragraph...',
    confirm: {
      title: 'delete',
      text: 'Are you sure you want to delete Finding {0}?',
      delete_image: 'Are you sure you want to delete this image?',
    },
    reset_timer: 'reset the timer',
    simple: 'Simple Ver.',
    normal: 'Normal Ver.',
    image_not_show_on_print: 'Image not show on print',
    select_landmarks: 'select landmarks',
    english_report: 'English Report',
    cleansing_comment1: 'During the examination, the doctor washed clean the residues remaining in the colon. Your cleansing level changed from ',
    cleansing_comment2: ' to ',
    cleansing_comment3: ', and all unclean areas are now clean. Please rest assured.',
    quality_report: 'Quality Report',
  },
  report_preview: {
    title: 'REPORT PREVIEW',
    ai: 'AI-powered medical report',
    back_to: 'Go back to editing',
    Gastroscopy: 'Gastroscopy Report',
    Colonoscopy: 'Colonoscopy Report',
    name: '@:patient.name',
    gender: 'Gender',
    age: '@:patient.age',
    recordNo: 'Med.Record',
    examDate: '@:examination.date',
    examTime: 'Exam. Time',
    examItem: 'Exam. Item',
    GastroscopyCheckNo: '28016C',
    ColonoscopyCheckNo: '28017C',
    findings: '@:report.findings',
    report_date: 'Report Date',
    technician: 'Technician',
    print: 'Print',
    explanation: 'Doctor\'s explanation',
    personal_info: 'Personal information',
    diff: 'Before-and-after comparison',
    cleanse_off: 'Cleaned up, please rest assured!',
    deepest: 'Check the deepest location',
    timer: {
      title: 'Endoscope withdrawal time',
      withdrawal: 'Withdrawal Time',
      proximal: 'Proximal Colon Withdrawal Time',
    },
    notice1: 'This examination does not have the image of the deepest colon, if you wish to display, please have the doctor mark the image of the deepest colon position on the examination image',
    notice2_start: 'The deepest colon is reached at ',
    notice2_end1: 'The deepest colon is reached at {0}. It has been fully examined and there is no loss. Please rest assured.',
    notice2_end2: 'Because',
    reason_describ: 'Cause description',
    describ: 'Description',
    insertion_level: 'Insertion level',
    insertion_length: 'Insertion length',
  },
  organization: {
    title: 'Organization',
    number: 'Organization No',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    connection: 'Connect to PACS Worklist',
    ae_title: 'Called_AE ',
    called_ip: 'Called_IP',
    called_port: 'Called_PORT',
    calling_ae: 'Calling_AE ',
    modality: 'Modality',
    record: 'Full-time Recording',
  },
  doctor: {
    title: 'Doctors',
    list: 'Doctor List',
    new_doctor_added: 'New doctor added',
    new_doctor: 'New doctor',
  },
  examination: {
    list: 'Examination List',
    title: 'Examinations',
    number: 'Examination Record',
    patient: '@:patient.name',
    date: 'Exam. Date',
    doctor: 'Order Doctor',
    type: 'Examination Type',
    add: 'Add Examination',
  },
  inspection_instrument: {
    title: 'Inspection Instruments',
    list: 'Inspection Instrument List',
    added: 'New Inspection Instrument Added',
    new: 'New Inspection Instrument',
    edit: 'Edit'
  },
  wash_Instrument: {
    title: 'Wash Instruments',
    list: 'Wash Instrument List', 
    added: 'New Wash Instrument Added',
    new: 'New Wash Instrument',
  },
  patient: {
    title: 'Patients',
    name: 'Patient',
    id: 'Medical Record',
    dob: 'Birthdate',
    sex: 'Gender',
    age: 'Age',
    list: 'Patient List',
    medical_record: 'Medical Record',
    choose: 'Choose',
    birthday: 'Birthday',
    add: 'Add Patient',
    gender: 'Gender',
    nation_id: 'Nation ID',
  },
  nurse: {
    title: 'Nurse',
    list: 'Nurse List',
    added: 'New Nurse Added',
    new_technical_staff: 'New Technical Staff',
  },
  user: {
    title: 'Users',
    list: 'User List',
    username: 'username',
    employee_type: 'employee Type',
    doctor: 'doctor',
    employee: 'employee',
    technical_staff: 'technical Staff',
    edit_pasword: 'Edit Password',
    voice_repeat: 'Voice Repeat',
    add_user: 'Add User',
    min_8_character: 'minimum 8 characters',
    atleast_8_character: 'at least 8 characters',
  },
  analytics: {
    title: 'Analytics',
    search: 'search',
    filter: 'filter',
    fields_to_display: 'fields to display',
    apply: 'apply',
    no_data_available: 'no data available',
    field: 'field',
    value: 'value',
    polyp_detection_rate: 'polyp detection rate',
    polyp_detection_rate_comparison: 'polyp detection rate comparison',
    time_interval: 'time interval',
    add_comparison: 'add comparison',
    generate: 'generate',
    ratio_of_withdrawal_time_6_min:'ratio of withdrawal time ≥ 6 min'
  },
  enviroment_test: {
    title: 'Enviroment Test',
    pedal: '踏板',
    camera: '攝影機',
    microphone: '麥克風',
    pedaling: '踩踏板',
    single_pedal: '單次',
    continuous_pedal: '持續',
    allow_camera: '允許使用攝影機',
    use_camera: '使用攝影機',
    use_microphone: '使用麥克風',
    capture_pedal: '踩踏板截圖',
    allow_microphone: '允許使用麥克風',
    capture_pedal_audio: '踩踏板錄音',
  },
  common: {
    name: 'Name',
    yes: 'Yes',
    no: "No",
    close: 'Close',
    cancel: 'Cancel',
    nil: "Nil",
    summary: 'Summary',
    search: 'Search',
    choose: 'Choose',
    reset: 'Reset',
    add: 'ADD',
    other: 'Other',
    other_image: 'More Images',
    day: 'day',
    loading: 'Loading',
    enable_continuous_recording: 'Enable Continuous Recording',
    gender: 'gender',
    field: 'field',
    value: 'value',
    excellent: 'Excellent',
    good: 'Good',
    fair: 'Fair',
    poor: 'Poor',
    male: 'Male',
    famale: 'Famle',
    insertion_time: 'Insertion Time',
    proximal_colon_withdrawal_time: 'Proximal Colon Withdrawal Time',
    withdraw_time: 'Withdrawal Time',
    total_exam: 'Total Exam',
    add_new_finding: 'Add new finding',
    send_report_to_email: 'Send generative report to the following Email',
    send_email: "Send",
    ESOPHAGUS: 'ESOPHAGUS',
    STOMACH: 'STOMACH',
    DUODENUM: 'DUODENUM',
    NONSPECIFIC: 'NONSPECIFIC',
    indication: 'Indication',
    preparation_agent: 'Preparation Agent',
    preparation_time: 'Preparation Time',
    anti_platelet: 'Anti platelet',
    anti_platelet_stop: 'Antiplatelet medication discontinuation',
    cleanse_level: {
      before: 'Cleanse Level(before)',
      after: 'Cleanse Level(after)',
    },
    scope_id: 'Scope ID',
    sedatives: 'Sedatives',
    start_date: 'Start Date',
    end_date: 'End Date',
    washing_machine: 'Washing machine',
    premedication: {
      title: 'Premedication',
      '1': 'Glaucoma',
      '2': 'BPH',
      '3': 'Tachycardia',
      '4': 'Allergy',
    },
    antispasmodics: {
      on: 'On antispasmodics',
      off: 'Off antispasmodics',
    },
    insertion_level: 'Insertion level',
    insertion_length: 'Insertion length',
    complication: "Complication",
    clo_test: 'CLO Test',
    additional_remarks: 'Additional Remarks',
    incomplete: {
      title: 'Incomplete study due to',
      gastro: {
        '0': '',
        '1': 'intolerance',
        '2': 'bleeding',
        '3': 'food stasis',
        '4': 'undigested medicine',
      },
      colon: {
        '0': '',
        '1': 'Poor Preparation',
        '2': 'Bleeding',
        '3': 'Bowel Perforation',
        '4': 'Patient Intolerance',
        '5': 'Other',
        '6': 'Food Stasis',
        '7': 'Undigested Medicine',
      }
    },
    procedure_note: 'Procedure Note',
    required: 'Required',
    not_specific: 'Not Specific',
    microphone: 'Microphone',
    camera: 'Camera',
  },
  right_sidebar: {
    insertion_time: 'Insertion Time',
    proximal_colon_withdrawal_time: 'Proximal Colon Withdrawal Time',
    withdraw_time: 'Withdrawal Time',
    total_exam: 'Total Exam',
    cleansing_level: 'Cleansing Level',
    complications: 'Complications',
    clo_test: "Clo test",
    location: "Location",
    pylorus: "pylorus",
    antrum: "antrum",
    lowbody: "low-body",
    record: "Record",
  },
  dialog: {
    warn: 'Warn',
    warning: 'Warning',
    reset_timer_confirm: 'This examination has already recorded time. Do you want to reset the timer?',
    save_success: 'Save successful',
    form_validation_error: 'Please check if the form is filled out correctly',
  },
  login:{
    username: "username",
    password: "password",  // NOSONAR
    verificationcode: "verification code",
    signin: "sign in"
  },
  homepage:{
    from: "From",
    to: "To",
    examination_records: "exammination records",
    medical_records: "Medical records",
    search: "search",
    today: "today",
    sync_worklist: "SYNC WORKLIST",
    examinations: "examinations",
    date: "date",
    examination_record: "examination record",
    examination_type: "examination type",
    patient_name: "Patient name",
    medical_record: "medical record",
    status: "status",
    no_data_available: "No data available",
    rows_per_page: "Rows per page",
    singout: "SING OUT",
    select_examination: "Select an examination from the left to see detail information.",
    finished: "Finished",
    unfinished: "Unfinished",
    colonoscopy: "Colonoscopy",
    gastroscopy: "Gastroscopy",
    sigmoidoscopy: "Sigmoidoscopy",
    gast:{
      birth: "DATE OF BIRTH",
      age: '@:patient.age',
      gender: "GENDER",
      male: "male",
      female: "female",
      scope_id: "Scope ID",
      washing_machine: "Washing Machine",
      doctor: "Doctor",
      nurse: "Nurse",
      go_to_report: "GO TO REPORT",
      start_examination: "START EXAMINATION",
    },
    colon:{
      premedication: "@:common.premedication.title",
      preparation_agent: "Preparation Agent",
      preparationTime: "Preparation Time",
      antiplatelet: "Antiplatelet",
      complication: "@:common.complication",
      without_medication: "Antiplatelet medication discontinuation",
      please_select: "Please select",
    }
  },

  poweredByFirst: 'Powered By',
  poweredBySecond: 'KENKONE EVAS',
  from: 'From',
  ward: 'Ward',
  applicationDate: 'Application Date',
  applicationTime: 'Application Time',
  applicationDr: 'Application DR',
  reportTime: 'Report Time',
  vs: 'VS.',
  examDr: 'EXAM. DR.',

  // ColonCloeanseForm
  informedConsent: 'Informed consent',
  insertionTime: 'Insertion Time',
  withdrawTime: 'Withdrawal Time',
  totalExamTime: 'Total Exam',
  proximalColonWithTime: 'Proximal Colon Withdrawal Time',

  // Colon finding
  finding: 'Finding',
  lesion: 'Lesion',
  procedureImages: 'Key Images',
  additionalImage: 'More Images',

  http: {
    error: {
      400: 'Bad Request',
      401: 'Unauthorized',
      403: 'Forbidden',
      404: 'Not Found',
      405: 'Method Not Allowed',
      406: 'Not Acceptable',
      408: 'Request Timeout',
      500: 'Internal Server Error',
      502: 'Bad Gateway',
      503: 'Service Unavailable',
      504: 'Gateway Timeout',
      505: 'HTTP Version Not Supported',
      999: 'JavaScript Error',
    },
  },
  i18n: {
    zh: '繁體中文',
    ja: '日本語',
    en: 'English',
    switch_language: 'Switch language',
    select_language: 'Switch to {language}',
  },
  paris_hint: {
    title: "Paris Endoscopic Classification",
    close: "Close",
    type_0_i: "0-I Protruding: lesion clearly protrudes into the lumen",
    type_0_ip: "0-Ip Pedunculated: protruding lesion with a stalk",
    type_0_is: "0-Is Sessile: broad-based protruding lesion without a stalk",
    type_0_ii: "0-II Superficial: superficial, little height difference from the mucosa",
    type_0_iia: "0-IIa Slightly elevated: surface slightly above the surrounding mucosa",
    type_0_iib: "0-IIb Flat: level with the surrounding mucosa",
    type_0_iic: "0-IIc Slightly depressed: surface slightly below the surrounding mucosa",
    type_0_iii: "0-III Excavated / ulcerated: clearly depressed or ulcerated lesion",
  },
  finding_words:{
    "2nd_portion": "2nd portion",
    "abscess": "abscess",
    "acetic_acid": "acetic acid",
    "active_bleeding": "active bleeding",
    "active": "active",
    "acute_gastritis": "acute gastritis",
    "adenomatous_polyp": "adenomatous polyp",
    "advanced": "advanced",
    "advanced_cancer": "advanced cancer",
    "advanced_colorectal_cancer": "advanced colorectal cancer",
    "all_segments_of_colon": "all segments of colon",
    "alligator": "alligator",
    "amoeba": "amoeba",
    "amoebic_colitis": "amoebic colitis",
    "amyloidosis": "amyloidosis",
    "anal_retroflex": "anal retroflex",
    "anastomosis": "anastomosis",
    "angiodysplasia": "angiodysplasia",
    "angle": "angle",
    "antrum": "antrum",
    "anus": "anus",
    "appendiceal_tumor": "appendiceal tumor",
    "appendix_orifice": "appendix orifice",
    "ascending_colon": "ascending colon",
    "atrophic_gastritis": "atrophic gastritis",
    "aw": "aw",
    "band_ligation": "band ligation",
    "barretts_esophagus": "barrett's esophagus",
    "bechets_disease": "bechet's disease",
    "bezoar": "bezoar",
    "bezoar_removal": "bezoar removal",
    "biopsy": "biopsy",
    "biopsy_and_removal": "biopsy and removal",
    "biopsy_forceps": "biopsy forceps",
    "biospy_forceps": "biospy forceps",
    "bleeding": "bleeding",
    "bleeding_continue": "bleeding continue",
    "bleeding_stop": "bleeding stop",
    "bleeding_tendency": "bleeding tendency",
    "blood_oozing": "blood oozing",
    "body": "body",
    "broad": "broad",
    "brunners_gland_hyperplasia": "brunner's gland hyperplasia",
    "bulb": "bulb",
    "bulbitis": "bulbitis",
    "cancer": "cancer",
    "cap": "cap",
    "carcinoid_tumor": "carcinoid tumor",
    "cardia": "cardia",
    "causes": "causes",
    "cecum": "cecum",
    "cervical": "cervical",
    "cherry-red_spot": "cherry-red spot",
    "chromag": "chromag",
    "chronic_esophagitis": "chronic esophagitis",
    "chronic_gastritis": "chronic gastritis",
    "chromo_sign": "chromo sign",
    "closed": "closed",
    "cm": "cm",
    "distance_cm": "cm",
    "size_cm": "cm",
    "coagrasper": "coagrasper",
    "cold_biopsy": "cold biopsy",
    "cold_snare": "cold snare",
    "colitis": "colitis",
    "colitis_aphthosa": "colitis aphthosa",
    "colon_fistula": "colon fistula",
    "colon_maltoma": "colon maltoma",
    "colon_polyposis": "colon polyposis",
    "colon_polyposis,familiar": "colon polyposis,familiar",
    "colonic_stricture": "colonic stricture",
    "colonic_tuberculosis": "colonic tuberculosis",
    "colonic_wall_cyst": "colonic wall cyst",
    "color": "color",
    "complete_obstruction": "complete obstruction",
    "completely_removed": "completely removed",
    "confluent": "confluent",
    "congenital": "congenital",
    "consent_not_obtained_from_the_patient": "Consent not obtained from the patient",
    "consult_surgeon": "consult surgeon",
    "consur": "consur",
    "continuous-lesion": "continuous-lesion",
    "crohns_disease": "crohn's disease",
    "cytomegalovirus_colitis": "cytomegalovirus colitis",
    "demarcation_line": "demarcation line",
    "description": "description",
    "descending_colon": "descending colon",
    "device": "device",
    "difficulty_in_management_refer_for_surgery": "difficulty in management (refer for surgery)",
    "difficulty_in_management_will_resect_at_another_sessio_of_colonoscopy": "difficulty in management \n (will resect at another sessio of colonoscopy)",
    "difficulty_in_management_refer_to_other_hospital": "difficulty in management(refer to other hospital)",
    "diffuse_redness": "diffuse redness",
    "diluted_epinephrine": "diluted epinephrine",
    "distance": "distance",
    "distal": "distal",
    "diverticula": "diverticula",
    "diverticular_bleeding": "diverticular bleeding",
    "diverticulitis": "diverticulitis",
    "diverticulosis": "diverticulosis",
    "diverticulum": "diverticulum",
    "drug_induce_colitis": "drug induce colitis",
    "du": "du",
    "dualknife": "dualknife",
    "dysplasia": "dysplasia",
    "each": "each",
    "early": "early",
    "early_cancer": "early cancer",
    "early_colorectal_cancer": "early colorectal cancer",
    "early_or_advanced": "early or advanced",
    "easy_bleeding": "easy bleeding",
    "ecj": "ecj",
    "edema": "edema",
    "elastic": "elastic",
    "elective": "elective",
    "emergent": "emergent",
    "en_bloc": "en bloc",
    "endolifter": "endolifter",
    "endoloop": "endoloop",
    "erosion": "erosion",
    "erosions": "erosions",
    "erythema": "erythema",
    "esophageal_ca": "esophageal ca",
    "esophageal_dysplasia": "esophageal dysplasia",
    "esophageal_stenosis": "esophageal stenosis",
    "esophageal_varices": "esophageal varices",
    "esophagus": "esophagus",
    "external": "external",
    "external_hemorrhoid": "external hemorrhoid",
    "extraluminal_impression": "extraluminal impression",
    "exudate": "exudate",
    "fap": "fap",
    "flat_erosion": "flat erosion",
    "flat_tumor": "flat tumor",
    "flexknife": "flexknife",
    "focal": "focal",
    "food_stasis": "food stasis",
    "foreign_body": "foreign body",
    "form": "form",
    "form_quantity_unit": "Qty",
    "form_quantity_clinic_readonly": "This record has per-grade quantities; please edit it in the main exam form",
    "fresh_blood": "fresh blood",
    "friability": "friability",
    "fundic_gland_polyp": "fundic gland polyp",
    "fundus": "fundus",
    "gastric_ca": "gastric ca",
    "gastric_dysplasia": "gastric dysplasia",
    "gastric_fold_hypertrophy": "gastric fold hypertrophy",
    "gastric_mucosa_atrophy": "gastric mucosa atrophy",
    "gastric_varices": "gastric varices",
    "gastritis": "gastritis",
    "gc": "gc",
    "gerd": "gerd",
    "gi_bleeding": "gi bleeding",
    "giant": "giant",
    "gist": "gist",
    "glycerol": "glycerol",
    "grade": "grade",
    "grasping_forceps": "grasping forceps",
    "gu": "gu",
    "gvhd_related_colitis": "gvhd related colitis",
    "hard": "hard",
    "healing": "healing",
    "heater_probe": "heater probe",
    "hemangioma": "hemangioma",
    "hematin": "hematin",
    "hemoclip": "hemoclip",
    "hemorrhagic_colitis": "hemorrhagic colitis",
    "hemorrhagic_gastritis": "hemorrhagic gastritis",
    "hemorrhoid": "hemorrhoid",
    "hemostasis": "hemostasis",
    "hepatic_flexure": "hepatic flexure",
    "hiatal_hernia": "hiatal hernia",
    "high-body": "high-body",
    "histoacryl": "histoacryl",
    "hookknife": "hookknife",
    "hot_biopsy": "hot biopsy",
    "hot_snare": "hot snare",
    "hyaluronic_acid": "hyaluronic acid",
    "hybrid_knife": "hybrid knife",
    "hyperplastic_polyp": "hyperplastic polyp",
    "ibd": "ibd",
    "I-sp": "I-sp",
    "iia+c": "iia+c",
    "iic+a": "iic+a",
    "ileitis": "ileitis",
    "ileocecal_valve": "ileocecal valve",
    "indigo_carmine": "indigo carmine",
    "infectious_colitis": "infectious colitis",
    "inflammation": "inflammation",
    "inflammatory_adenoma": "inflammatory adenoma",
    "inflammatory_polyp": "inflammatory polyp",
    "infrared_coagulation": "infrared coagulation",
    "injection": "injection",
    "internal": "internal",
    "internal_hemorrhoid": "internal hemorrhoid",
    "intervention": "intervention",
    "intestinal_metaplasia": "intestinal metaplasia",
    "intramural_bleeding_spots": "intramural bleeding spots",
    "intraoperative_condition": "intraoperative condition",
    "intussusception": "intussusception",
    "ischemia": "ischemia",
    "ischemic_colitis": "ischemic colitis",
    "itknife": "itknife",
    "itknife_nano": "itknife nano",
    "itknife-2": "itknife-2",
    "juvenile_polyp": "juvenile polyp",
    "kudo": "kudo",
    "l.a_grade": "l.a grade",
    "lateral_spreading_tumor": "lateral spreading tumor",
    "lc": "lc",
    "left_hemicolectomy": "left hemicolectomy",
    "lipiodol": "lipiodol",
    "lipoma": "lipoma",
    "location": "location",
    "low-body": "low-body",
    "lower": "lower",
    "lower_gi": "lower gi",
    "lower_gi_bleeding": "lower gi bleeding",
    "lugol-voiding": "lugol-voiding",
    "lugols_solution": "lugol's solution",
    "lymphangioma": "lymphangioma",
    "lymphoid_follicles": "Lymphoid follicles",
    "lymphoid_hyperplasia": "lymphoid hyperplasia",
    "lymphoma": "lymphoma",
    "magnification": "magnification",
    "major_bleeding": "major bleeding",
    "malignancy": "malignancy",
    "maneuver": "maneuver",
    "mega_colon": "mega colon",
    "melanosis_coli": "melanosis coli",
    "metastatic_tumor": "metastatic tumor",
    "mid-body": "mid-body",
    "middle": "middle",
    "minor_bleeding": "minor bleeding",
    "mixed": "mixed",
    "mixed_hemorrhoid": "mixed hemorrhoid",
    "morphology": "morphology",
    "mucosa_prolapse": "mucosa prolapse",
    "mucus_plaque": "mucus plaque",
    "multiple": "multiple",
    "nearly_complete_obstruction": "nearly complete obstruction",
    "necrosis": "necrosis",
    "needle_knife": "needle knife",
    "negative": "negative",
    "net": "net",
    "nil": "nil",
    "nipple_sign": "nipple sign",
    "nodularity": "nodularity",
    "non-specific_colitis": "non-specific colitis",
    "number": "number",
    "object": "object",
    "obstruction": "obstruction",
    "occult_bleeding": "occult bleeding",
    "operation_scar": "operation scar",
    "orientation": "orientation",
    "clock_1": "1 o'clock",
    "clock_2": "2 o'clock",
    "clock_3": "3 o'clock",
    "clock_4": "4 o'clock",
    "clock_5": "5 o'clock",
    "clock_6": "6 o'clock",
    "clock_7": "7 o'clock",
    "clock_8": "8 o'clock",
    "clock_9": "9 o'clock",
    "clock_10": "10 o'clock",
    "clock_11": "11 o'clock",
    "clock_12": "12 o'clock",
    "other": "other",
    "others": "others",
    "overall": "overall",
    "overlying_membrane": "overlying membrane",
    "papilla": "papilla",
    "paris": "paris",
    "partial_obstruction": "partial obstruction",
    "patho": "patho",
    "pedunculated": "pedunculated",
    "pentapod_grasping_forceps": "pentapod grasping forceps",
    "perforation": "perforation",
    "petechia": "petechia",
    "peutz-jeghers_syndrome": "peutz-jeghers syndrome",
    "pieces_of_tissue": "pieces of tissue",
    "pillow_sign": "pillow sign",
    "pink-color_sign": "pink-color sign",
    "polyp": "polyp",
    "polypectomy": "polypectomy",
    "polypoid_tumor": "polypoid tumor",
    "portal_hypertensive_gastropathy": "portal hypertensive gastropathy",
    "positive": "positive",
    "rcs_present": "present",
    "rcs_absent": "absent",
    "post_endoscopy_treatment_scar": "post endoscopy treatment scar",
    "post_operation": "post operation",
    "post-treatment_residual_neoplasm": "post-treatment residual neoplasm",
    "prague_c": "prague c",
    "prague_m": "prague m",
    "proctitis": "proctitis",
    "proximal": "proximal",
    "pseudomembranous_colitis": "pseudomembranous colitis",
    "pw": "pw",
    "radiation_colitis": "radiation colitis",
    "raised_erosion": "raised erosion",
    "red_color_sign": "red color sign",
    "recent_bleeding": "recent bleeding",
    "rectal_varices": "rectal varices",
    "rectum": "rectum",
    "red_whale_marking": "red whale marking",
    "reflux_esophagitis": "reflux esophagitis",
    "removal_forceps": "removal forceps",
    "removed": "removed",
    "right_hemicolectomy": "right hemicolectomy",
    "r/o": "r/o",
    "rs_junction": "rs junction",
    "rubber_band": "rubber band",
    "rugal_atrophy": "rugal atrophy",
    "rugal_hypertrophy": "rugal hypertrophy",
    "s/p_endolooping": "s/p endolooping",
    "s/p_hemoclipping": "s/p hemoclipping",
    "s/p_partial_colectomy": "s/p partial colectomy",
    "s/p_stenting": "s/p stenting",
    "s/p_tattooing": "s/p tattooing",
    "saline": "saline",
    "sb_tube": "sb tube",
    "scar": "scar",
    "ulcer_scar": "scar",
    "scattered": "scattered",
    "sclerotherapy": "sclerotherapy",
    "sda": "sda",
    "sessile": "sessile",
    "sessile_serrated_adenoma": "sessile serrated adenoma",
    "several": "several",
    "shallow": "shallow",
    "sigmoid_colon": "sigmoid colon",
    "sign": "sign",
    "silver_sign": "silver sign",
    "situs_inversus": "situs inversus",
    "size": "size",
    "skip-lesion": "skip-lesion",
    "skiplesion": "skiplesion",
    "small": "small",
    "snare": "snare",
    "soft": "soft",
    "sessile_or_pedunculated": "sessile or pedunculated",
    "s_pattern": "s pattern",
    "specimen_label": "specimen label",
    "splenic_flexure": "splenic flexure",
    "spotted": "spotted",
    "stich": "stich",
    "stitches": "stitches",
    "stretta": "stretta",
    "subepithelial_tumor": "subepithelial tumor",
    "subtotal_gastrectomy": "subtotal gastrectomy",
    "sucralfate_gel": "sucralfate gel",
    "superficial_gastritis": "superficial gastritis",
    "suture_granuloma": "suture granuloma",
    "swelling_mucosa": "swelling mucosa",
    "take_note_of": "take note of",
    "tarry_stool": "tarry stool",
    "tb_colitis": "tb colitis",
    "tb_related_lesion": "tb related lesion",
    "terminal_ileum": "terminal ileum",
    "the_most_significant": "the most significant",
    "tiny": "tiny",
    "tooth": "tooth",
    "total_gastrectomy": "total gastrectomy",
    "traditional_serrated_adenoma": "traditional serrated adenoma",
    "transverse_colon": "transverse colon",
    "triangle_knife": "triangle knife",
    "tubular_adenoma": "tubular adenoma",
    "tubulovillous_adenoma": "tubulovillous adenoma",
    "tumor": "tumor",
    "ulcer": "ulcer",
    "ulcerative": "ulcerative",
    "ulcerative_colitis": "ulcerative colitis",
    "ulcer_stage": "ulcer stage",
    "unexpected_trouble_during_management_cardiopulmonary_event_other_complicaiotn_mechanical_etc": "unexpected trouble during management(cardiopulmonary event, other complicaiotn, mechanical, etc.",
    "unknown_bleeder": "unknown bleeder",
    "upper": "upper",
    "upper_gi": "upper gi",
    "upper_gi_bleeding": "upper gi bleeding",
    "use_of_anti-platelet_or_anti-coagulant": "use of anti-platelet or anti-coagulant",
    "v_pattern": "v pattern",
    "villous_adenoma": "villous adenoma",
    "visibility_of_vascular_pattern": "visibility of vascular pattern",
    "xanthoma": "xanthoma",
    "yellow": "yellow",
    "white": "white",
    "blue": "blue",
  },
  const_words: {
    perforation: "Perforation",
    nil: "Nil",
    significant_bleeding: "Significant Bleeding",
    cardiopulmonary_complication: "Cardiopulmonary Complication",
    pylorus: "pylorus",
    antrum: "antrum",
    lowbody: "low-body",
    terminalileum: "Terminal ileum",
    cecum: "Cecum",
    ascendingcolon: "Ascending colon",
    hepaticflexure: "Hepatic flexure",
    transversecolon: "Transverse colon",
    splenicflexure: "Splenic flexure",
    descendingcolon: "Descending colon",
    sigmoidcolon: "Sigmoid colon",
    rectum: "Rectum",
    anastomosis: "Anastomosis",
    anus: "Anus",
    ileocecalvalve: "Ileocecal valve",
    appendixorifice: "Appendix orifice",
    proximalascendingcolon: "Proximal Ascending Colon",
    middleascendingcolon: "Middle Ascending Colon",
    distalascendingcolon: "Distal Ascending Colon",
    proximaltransversecolon: "Proximal Transverse colon",
    middletransversecolon: "Middle Transverse colon",
    distaltransversecolon: "Distal Transverse colon",
    proximaldescendingcolon: "Proximal Descending Colon",
    middledescendingcolon: "Middle Descending Colon",
    distaldescendingcolon: "Distal Descending Colon",
    proximalsigmoidcolon: "Proximal Sigmoid Colon",
    middlesigmoidcolon: "Middle Sigmoid Colon",
    distalsigmoidcolon: "Distal Sigmoid Colon",
    rsjunction: "RS junction",
    upperrectum: "Upper Rectum",
    midrectum: "Middle Rectum",
    lowerrectum: "Lower Rectum",
    rsjunction: "RS junction",
    analretroflex: "Anal retroflex",
    allsegments: "All segments of colon",
  },
  examination_detail: {
    exam_type: "Exam. Type",
    exam_record: "Exam. Record",
    name: "Name",
    med_record: "Med. Record",
    delete_finding_start: "刪除 Finding",
    delete_finding_end: "，原本的Finding編號，將會被取代，確定要刪除嗎？",
    delete_finding: "Delete",
    orientation: "orientation",
    location: "location",
    from_incisor: "from incisor",
    delete_image_confirm: "確定要刪除此圖片?",
    delete_image_confirm_yes: "是的",
    delete_image_confirm_no: "取消",
  },
  indication:{
    title: "適應症",
    item1: "國健局糞便潛血檢查陽性",
    item2: "自費健康檢查",
    item9a: "大腸癌家族史",
    item9b: "瘜肉切除後追蹤",
    item9c: "大腸癌術後追蹤",
    item9e: "瘜肉或腫瘤切除",
    item9f: "發炎性腸道疾病追蹤",
    item9g: "術前評估",
  }
}
